export default __webpack_public_path__ + "static/media/printIconDisabled.e16912f2.svg";